import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Attach token if exists
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("apex_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Token expired or invalid
      const wasLoggedIn = !!localStorage.getItem("apex_token");
      localStorage.removeItem("apex_token");
      localStorage.removeItem("apex_user");
      if (wasLoggedIn && !window.location.pathname.startsWith("/login")) {
        // Soft reload state without forcing redirect
        window.dispatchEvent(new Event("apex:logout"));
      }
    }
    return Promise.reject(err);
  }
);

export default api;
